import { create } from 'zustand';
import { createJSONStorage, persist } from 'zustand/middleware';

type SidebarCollapseStore = {
  isCollapsed: boolean;
  toggleCollapsed: () => void;
};

export const useSidebarCollapseStore = create<SidebarCollapseStore>()(
  persist(
    (set) => ({
      isCollapsed: false,
      toggleCollapsed: () => set((state) => ({ isCollapsed: !state.isCollapsed })),
    }),
    {
      name: 'sidebar-collapsed-preference',
      storage: createJSONStorage(() => localStorage),
    },
  ),
);
